import { render, staticRenderFns } from "./CoinAvatar.vue?vue&type=template&id=5cd9df2c&scoped=true"
import script from "./CoinAvatar.vue?vue&type=script&lang=js"
export * from "./CoinAvatar.vue?vue&type=script&lang=js"
import style0 from "./CoinAvatar.vue?vue&type=style&index=0&id=5cd9df2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd9df2c",
  null
  
)

export default component.exports